import { render } from "./services.html?vue&type=template&id=1ff20e20&external"
import script from "./services.js?vue&type=script&lang=js&external"
export * from "./services.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__